import Draggable from 'draggable'

import EventEmitter from 'amkit3-modules/utils/stateful-events'
import UIEvent from 'amkit3-modules/v/ui/ui-event'

import themeFactory from './themes/factory'

const limit = { x: [0, 82], y: 0 }

class VolumeSlider extends EventEmitter {
  constructor ($, $container) {
    super()

    this.$ = $
    this.$container = $container
    this.style = themeFactory.getStyle()
    this.selector = themeFactory.getSelector()
    this.$element = this.$container.find(this.selector.controlBarVolume)
    this.$slider = this.$container.find(this.selector.controlBarVolumeSlider)
    this.$handle = this.$container.find(this.selector.controlBarVolumeSliderHandle)
    this.handleRadius = typeof this.$handle.outerWidth === 'function' ? this.$handle.outerWidth() / 2 : this.$handle.width() / 2
    this.draggable = new Draggable(this.$handle[0], {
      limit,
      onDrag: (element, x, y, event) => {
        this.volume = Math.max(0, Math.min(1, x / limit.x[1]))
        this.emit(UIEvent.VOLUME_CHANGE)
      }
    })
    this.$container.on('click', this.selector.controlBarVolumeSlider, this.statefulDelegate(evt => {
      let percentage = Math.max(0, Math.min(1, (evt.pageX - this.$slider.offset().left - 4) / limit.x[1]))
      this.draggable.set(percentage * limit.x[1], 0)
      this.volume = percentage
      this.emit(UIEvent.VOLUME_CHANGE)
    }))
  }
  getVolume () {
    return this.volume
  }
  setVolume (value) {
    this.volume = value
    this.draggable.set(value * limit.x[1], 0)
  }
}

export default VolumeSlider
